import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KbOpenPositionService {
  openPositionForm$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private occService: OccEndpointsService) {}

  getOpenPosition() {
    return this.http.get(this.occService.buildUrl('myaccount/open-positions'));
  }

  searchOpenPositions(payload: any, currentPage?: number, sort?: string) {
    return this.http.post(this.occService.buildUrl('myaccount/open-positions/search'), payload, {
      params: { currentPage, sort },
    });
  }

  exportExcelMyHistory(payload) {
    return this.http.post(this.occService.buildUrl(`/myaccount/exportOpenPositions`), payload);
  }
}
